<template>
  <div class="mb-4" v-if="nrePage.nreData">

    <!--#region -- Content ---->

    <div class="stage-header border-bottom mb-4">
      <!--#region Header-->
      <div class="caption-label">
        Basic Information
        <b-badge style="margin-left: 13.5px;" v-if="$attrs.isETOSELECT" variant="primary">ETO Sector SKU</b-badge>
      </div>
      <div class="row mb-4">
        <div class="col-4">
          <div class="header-col">
            <div>FTIE ID</div>
            <div><gtc-ftie :ftieId="basic_info_review.ftie_id" /></div>
          </div>
          <div class="header-col">
            <div>ETO NRE</div>
            <div>{{ basic_info_review.nre_id }}</div>
          </div>
          <div class="header-col">
            <div>Salesforce ES</div>
            <div>{{ basic_info_review.sales_force_es_no }}</div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Salesforce Opportunity</div>
            <gtc-opportunity :opportunityId="basic_info_review.sales_force_opty_id"
                             :opportunityName="basic_info_review.sales_force_opty" />
          </div>
          <div class="header-col">
            <div>Account Name</div>
            <div>{{ basic_info_review.account }}</div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Product</div>
            <div>{{ basic_info_review.nre_model }}</div>
          </div>
          <div class="header-col">
            <div>Customization SKU ID</div>
            <div>{{ basic_info_review.sku_id }}</div>
          </div>
        </div>
      </div>
      <!--#endregion Header-->
    </div>
    <!--#endregion-->
    <!--#region Customization Proposal-->
    <div class="stage-header border-bottom mb-4">
      <div class="stage-body-customization-proposal">
        <div class="caption-label">Customization Proposal</div>
        <div>
          <gtc-froala :read-only="true" v-model="nre_estimation_hq_sales.customization_proposal" />
        </div>
      </div>
      <div><br /><br /></div>
    </div>
    <!--#endregion: Customization Proposal-->

    <div style="margin-bottom: 6rem;">
      <div class="border-bottom pb-4 mb-4">
        <div class="row">
          <div class="col-auto" style="min-width: 60rem;">
            <!--#region NRE Estimation-->
            <div class="stage-body-nre-estimation">
              <div class="caption-label">NRE Estimation</div>
              <div>
                <div class="header-col">
                  <div>Module</div>
                  <div class="flex-fill">
                    <gtc-text-box :read-only="true" class="" v-model="nre_estimation_hq_sales.module" />
                  </div>
                </div>
                <div class="header-col">
                  <div>PoC Required</div>
                  <div>
                    {{ nre_estimation_hq_sales.poc_required === 'Y' ? 'Yes' : 'No' }}
                  </div>
                </div>
                <!--#region Table-->
                <div class="mt-3">
                  <table class="table nre-estimation-table table-sm">
                    <colgroup>
                      <col style="width: 1px;" />
                      <col />
                      <col style="width: 6rem;" />
                      <col style="width: 6rem;" />
                      <col style="width: 8.9rem;" />
                      <col style="width: 8.9rem;" />
                    </colgroup>
                    <thead class="text-dark thead-light">
                      <tr>
                        <th rowspan="2" class="align-middle text-center">Category</th>
                        <th rowspan="2" class="align-middle text-center">Item</th>
                        <th colspan="2" class="text-center">HQ Sales</th>
                        <th colspan="2" class="text-center">SA Head</th>
                      </tr>
                      <tr>
                        <th class="text-center">{{ $attrs.pocWordingHQ }}</th>
                        <th class="text-center">{{ $attrs.mpWordingHQ }}</th>
                        <th class="text-center">{{ $attrs.pocWordingGRO }}</th>
                        <th class="text-center">{{ $attrs.mpWordingGRO }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!--#region Labor Cost-->
                      <tr>
                        <td rowspan="2">Labor Cost</td>
                        <td>Development</td>
                        <td rowspan="2"><gtc-number :read-only="true" v-model="nre_estimation_hq_sales.labor_cost.poc_cost" /></td>
                        <td rowspan="2"><gtc-number :read-only="true" v-model="nre_estimation_hq_sales.labor_cost.mp_cost" /></td>
                        <td rowspan="2"><gtc-number percentage :read-only="$attrs.readOnly || !pocRequired" :base="nre_estimation_hq_sales.labor_cost.poc_cost" v-model="nre_estimation_curr_stage.labor_cost.poc_cost" /></td>
                        <td rowspan="2"><gtc-number percentage :read-only="$attrs.readOnly" :base="nre_estimation_hq_sales.labor_cost.mp_cost" v-model="nre_estimation_curr_stage.labor_cost.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td>Verification</td>
                      </tr>
                      <!--#endregion-->
                      <!--#region Test Sample-->
                      <tr>
                        <td>Test Sample</td>
                        <td>EQT Test Sample</td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_hq_sales.test_sample.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_hq_sales.test_sample.mp_cost" /></td>
                        <td><gtc-number percentage :read-only="$attrs.readOnly || !pocRequired" :base="nre_estimation_hq_sales.test_sample.poc_cost" v-model="nre_estimation_curr_stage.test_sample.poc_cost" /></td>
                        <td><gtc-number percentage :read-only="$attrs.readOnly" :base="nre_estimation_hq_sales.test_sample.mp_cost" v-model="nre_estimation_curr_stage.test_sample.mp_cost" /></td>
                      </tr>

                      <!--#endregion-->
                      <!--#region Job Cost-->
                      <tr>
                        <td rowspan="5">Job Cost</td>
                        <td>Tooling Fee</td>
                        <td rowspan="5"><gtc-number :read-only="true" v-model="nre_estimation_hq_sales.job_cost.poc_cost" /></td>
                        <td rowspan="5"><gtc-number :read-only="true" v-model="nre_estimation_hq_sales.job_cost.mp_cost" /></td>
                        <td rowspan="5"><gtc-number percentage :read-only="$attrs.readOnly || !pocRequired" :base="nre_estimation_hq_sales.job_cost.poc_cost" v-model="nre_estimation_curr_stage.job_cost.poc_cost" /></td>
                        <td rowspan="5"><gtc-number percentage :read-only="$attrs.readOnly" :base="nre_estimation_hq_sales.job_cost.mp_cost" v-model="nre_estimation_curr_stage.job_cost.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td>PCB Fabrication Fee</td>
                      </tr>
                      <tr>
                        <td>Test Jig / Fixture</td>
                      </tr>
                      <tr>
                        <td>Outsource Fee</td>
                      </tr>
                      <tr>
                        <td>
                          <div class="row mx-n1">
                            <div class="px-1 col-auto">Others - </div>
                            <div class="px-1 col">
                              <pre class="mb-0 font-size-base font-family-base">{{ nre_estimation_hq_sales.job_cost.remark }}</pre>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <!--#endregion-->
                      <!--#region Regulation-->
                      <tr>
                        <td rowspan="4">Regulation</td>
                        <td>
                          <div class="row mx-n1">
                            <div class="px-1 col-auto">EMC - </div>
                            <div class="px-1 col">
                              <pre class="mb-0 font-size-base font-family-base">{{ nre_estimation_hq_sales.regulation.emc_remark }}</pre>
                            </div>
                          </div>
                        </td>
                        <td rowspan="4"><gtc-number :read-only="true" v-model="nre_estimation_hq_sales.regulation.regulation_others.poc_cost" /></td>
                        <td rowspan="4"><gtc-number :read-only="true" v-model="nre_estimation_hq_sales.regulation.regulation_others.mp_cost" /></td>
                        <td rowspan="4"><gtc-number percentage :read-only="$attrs.readOnly || !pocRequired" :base="nre_estimation_hq_sales.regulation.regulation_others.poc_cost" v-model="nre_estimation_curr_stage.regulation.regulation_others.poc_cost" /></td>
                        <td rowspan="4"><gtc-number percentage :read-only="$attrs.readOnly" :base="nre_estimation_hq_sales.regulation.regulation_others.mp_cost" v-model="nre_estimation_curr_stage.regulation.regulation_others.mp_cost" /></td>
                      </tr>
                      <tr>
                        <td>
                          <div class="row mx-n1">
                            <div class="px-1 col-auto">Safety - </div>
                            <div class="px-1 col">
                              <pre class="mb-0 font-size-base font-family-base">{{ nre_estimation_hq_sales.regulation.safety_remark }}</pre>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div class="row mx-n1">
                            <div class="px-1 col-auto">Environmental - </div>
                            <div class="px-1 col">
                              <pre class="mb-0 font-size-base font-family-base">{{ nre_estimation_hq_sales.regulation.environment_remark }}</pre>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div class="row mx-n1">
                            <div class="px-1 col-auto">Others - </div>
                            <div class="px-1 col">
                              <pre class="mb-0 font-size-base font-family-base">{{ nre_estimation_hq_sales.regulation.regulation_others.remark }}</pre>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <!--#endregion-->
                      <!--#region Others-->
                      <tr>
                        <td colspan="2">
                          <div class="row mx-n1">
                            <div class="px-1 col-auto">Others - </div>
                            <div class="px-1 col">
                              <pre class="mb-0 font-size-base font-family-base">{{ nre_estimation_hq_sales.others.remark }}</pre>
                            </div>
                          </div>
                        </td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_hq_sales.others.poc_cost" /></td>
                        <td><gtc-number :read-only="true" v-model="nre_estimation_hq_sales.others.mp_cost" /></td>
                        <td><gtc-number percentage :read-only="$attrs.readOnly || !pocRequired" :base="nre_estimation_hq_sales.others.poc_cost" v-model="nre_estimation_curr_stage.total_cost.poc_cost" /></td>
                        <td><gtc-number percentage :read-only="$attrs.readOnly" :base="nre_estimation_hq_sales.others.mp_cost" v-model="nre_estimation_curr_stage.total_cost.mp_cost" /></td>
                      </tr>
                      <!--#endregion-->
                    </tbody>
                    <tfoot>
                      <tr>
                        <td>Total NRE</td>
                        <td></td>
                        <td class="text-right font-weight-normal font-size-base">{{ nre_estimation_total_poc_cost | comma }}</td>
                        <td class="text-right font-weight-normal font-size-base">{{ nre_estimation_total_mp_cost | comma }}</td>
                        <td class="text-right font-weight-normal font-size-base">{{ nre_estimation_total_poc_cost_curr_stage | comma }}</td>
                        <td class="text-right font-weight-normal font-size-base">{{ nre_estimation_total_mp_cost_curr_stage | comma }}</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                <!--#endregion-->
              </div>
            </div>
            <!--#endregion-->
          </div>
          <div class="col">
            <!--#region Project Proposal File-->
            <div class="stage-body-project-proposal-file mt-3">
              <div class="caption-label d-flex">
                <div>Project Proposal File</div>
              </div>
              <div>
                <b-table small thead-class="thead-light text-dark"
                         :items="proposal_files" :fields="nrePage.projectProposalFileSetting">
                  <template #cell(file_name)="data">
                    <a herf="#" class="file" @click="$emit('getFile',data.item)">{{data.item.file_name}}</a>
                  </template>
                  <template #cell(update_time)="data">
                    {{ data.item.update_time | dateTimeFormat }}
                  </template>
                </b-table>
              </div>
            </div>
            <!--#endregion-->
          </div>
        </div>
      </div>
      <!-- Region: Ref SKU Info -->
      <div class="stage-header border-bottom mb-4">
        <div class="caption-label">Reference(Standard) SKU Price Information</div>
        <div class="row mb-4">
          <div class="col-4">
            <div class="row">
              <div class="col-auto">
                <div class="header-col">
                  <div>Standard SKU ID</div>
                  <div>{{ _.get(skuItem, 'sku_id', '') }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="header-col">
              <div>Distributor Price</div>
              <div>{{$attrs.currencySign}} {{ _.get(skuItem, 'price_info.distributor_price', '') | comma }}</div>
            </div>
            <div class="header-col">
              <div>Reseller Price</div>
              <div>{{$attrs.currencySign}} {{ _.get(skuItem, 'price_info.reseller_price', '') | comma }}</div>
            </div>
            <div class="header-col">
              <div>MSRP</div>
              <div>{{$attrs.currencySign}} {{ _.get(skuItem, 'price_info.msrp', '') | comma }}</div>
            </div>
          </div>
        </div>
      </div>
      <!--#endregion: ref sku info-->
      <!--#region Cost Per Unit Estimation-->
      <div class="stage-body-cost-per-unit-estimation border-bottom pb-4 mb-4">
        <div class="caption-label">Cost Per Unit Estimation</div>
        <div>
          <table class="table table-sm cost-per-unit-estimation-table">
            <colgroup>
              <col style="width:1px;" />
              <col style="width:6rem;" />
              <col style="width:6rem;" />
              <col style="width:8.9rem;" />
              <col style="width:8.9rem;" />
              <col />
            </colgroup>
            <thead class="text-dark thead-light">
              <tr>
                <th class="text-nowrap text-center align-middle" rowspan="2">Category</th>
                <th class="text-nowrap text-center align-middle" colspan="2">HQ Sales</th>
                <th class="text-nowrap text-center align-middle" colspan="2">SA Head</th>
                <th class="text-nowrap text-center align-middle" rowspan="2">Remark</th>
              </tr>
              <tr>
                <th class="text-nowrap text-center align-middle">{{ $attrs.pocWordingHQ }}</th>
                <th class="text-nowrap text-center align-middle">{{ $attrs.mpWordingHQ }}</th>
                <th class="text-nowrap text-center align-middle">{{ $attrs.pocWordingGRO }}</th>
                <th class="text-nowrap text-center align-middle">{{ $attrs.mpWordingGRO }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Demand Quantity</td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_hq_sales.demand_quantity.poc_cost" :decimalLen="0" /></td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_hq_sales.demand_quantity.mp_cost" :decimalLen="0" /></td>
                <td><gtc-number :read-only="$attrs.readOnly || !pocRequired" v-model="unit_estimation_curr_stage.demand_quantity.poc_cost" :decimalLen="0" /></td>
                <td><gtc-number :read-only="$attrs.readOnly" v-model="unit_estimation_curr_stage.demand_quantity.mp_cost" :decimalLen="0" /></td>
                <td><gtc-text-box :read-only="true" class="" v-model="unit_estimation_hq_sales.demand_quantity.remark" /></td>
              </tr>
              <tr>
                <td>
                  <div>(A) NRE Amortization / Per unit (for MP)</div>
                  <div class="p-tab d-flex align-items-center">
                    <b-form-checkbox v-model="unit_estimation_curr_stage.nre_amortization.nre_amortization_check"
                                     :disabled="$attrs.readOnly"
                                     @change="unit_estimation_curr_stage.nre_amortization.nre_amortization_quantity = 0"
                                     value="Y" unchecked-value="N">NRE Amortization Quantity:</b-form-checkbox>

                    <gtc-number :read-only="$attrs.readOnly || unit_estimation_curr_stage.nre_amortization.nre_amortization_check !== 'Y'"
                                :decimalLen="0" class="ml-2 text-right min-w-6"
                                v-model="unit_estimation_curr_stage.nre_amortization.nre_amortization_quantity" />

                  </div>
                </td>
                <td class="text-center">–</td>
                <td><gtc-number :read-only="true" v-model="nre_amortization_cost_hq_result" /></td>
                <td class="text-center">–</td>
                <td><gtc-number :read-only="true" v-model="nre_amortization_cost_gro_result" /></td>
                <td class="px-2">–</td>
              </tr>
              <tr>
                <td>
                  <div>(B) Cost of Base unit</div>
                  <div class="p-tab d-flex align-items-center">
                    <div>Reference PN:</div>
                    <div class="ml-2">{{ unit_estimation_hq_sales.cost_base_unit.remark }}</div>
                  </div>
                </td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_hq_sales.cost_base_unit.poc_cost" /></td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_hq_sales.cost_base_unit.mp_cost" /></td>
                <td><gtc-number percentage :read-only="$attrs.readOnly || !pocRequired" :base="unit_estimation_hq_sales.cost_base_unit.poc_cost" v-model="unit_estimation_curr_stage.cost_base_unit.poc_cost" /></td>
                <td><gtc-number percentage :read-only="$attrs.readOnly" :base="unit_estimation_hq_sales.cost_base_unit.mp_cost" v-model="unit_estimation_curr_stage.cost_base_unit.mp_cost" /></td>
                <td class="px-2">–</td>
              </tr>
              <tr>
                <td>(C) Additional Material Cost / Per unit</td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_hq_sales.additional_material_cost.poc_cost" /></td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_hq_sales.additional_material_cost.mp_cost" /></td>
                <td><gtc-number percentage :read-only="$attrs.readOnly || !pocRequired" :base="unit_estimation_hq_sales.additional_material_cost.poc_cost" v-model="unit_estimation_curr_stage.additional_material_cost.poc_cost" /></td>
                <td><gtc-number percentage :read-only="$attrs.readOnly" :base="unit_estimation_hq_sales.additional_material_cost.mp_cost" v-model="unit_estimation_curr_stage.additional_material_cost.mp_cost" /></td>
                <td><gtc-text-box :read-only="true" class="" v-model="unit_estimation_curr_stage.additional_material_cost.remark" /></td>
              </tr>
              <tr>
                <td>(D) Additional MVA Cost / Per unit</td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_hq_sales.additional_mva_cost.poc_cost" /></td>
                <td><gtc-number :read-only="true" v-model="unit_estimation_hq_sales.additional_mva_cost.mp_cost" /></td>
                <td><gtc-number percentage :read-only="$attrs.readOnly || !pocRequired" :base="unit_estimation_hq_sales.additional_mva_cost.poc_cost" v-model="unit_estimation_curr_stage.additional_mva_cost.poc_cost" /></td>
                <td><gtc-number percentage :read-only="$attrs.readOnly" :base="unit_estimation_hq_sales.additional_mva_cost.mp_cost" v-model="unit_estimation_curr_stage.additional_mva_cost.mp_cost" /></td>
                <td><gtc-text-box :read-only="true" v-model="unit_estimation_hq_sales.additional_mva_cost.remark" /></td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>Total cost/Per unit (=A+B+C+D)</td>
                <td class="text-right font-weight-normal font-size-base">{{ unit_estimation_total_hq_poc_cost | comma }}</td>
                <td class="text-right font-weight-normal font-size-base">{{ unit_estimation_total_hq_mp_cost | comma }}</td>
                <td class="text-right font-weight-normal font-size-base">{{ unit_estimation_total_gro_poc_cost | comma }}</td>
                <td class="text-right font-weight-normal font-size-base">{{ unit_estimation_total_gro_mp_cost | comma }}</td>
                <td>
                  <div>GP for MP Unit: {{ $attrs.gpMpUnit }}% , GP for POC Unit: {{ $attrs.gpPocUnit }}%</div>
                  <div v-if="unit_estimation_curr_stage.nre_amortization.nre_amortization_check==='Y'">GP for MP Unit: {{ $attrs.gpMpUnitWithNreAmortizationQuantity }}% (Incl. the NRE amortization)</div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <!--#endregion-->
      <!--#region Lead-time Estimation and Notices-->
      <div class="stage-body-lead-time-estimation-and-notices border-bottom pb-4 mb-4">
        <div class="caption-label">Lead-time Estimation and Notices</div>
        <div>
          <gtc-froala :read-only="true" v-model="lead_time_notice.note_text" />
        </div>
      </div>
      <!--#endregion-->
      <!--#region ETO Sector SKU INFO : P/N -->
      <div v-if="$attrs.isETOSELECT" style="margin-bottom: 6rem;">
        <div class="row">
          <div class="col-auto" style="min-width: 60rem;">
            <div class="stage-body-nre-estimation">
              <div class="caption-label">ETO Sector SKU P/N and Limitations</div>
              <div>
                <div class="header-col">
                  <div>MPS P/N<span class="text-danger pl-1">*</span></div>
                  <div class="flex-fill">
                    <gtc-text-box :read-only="true" class="" v-model="basic_info_review.eto_sector_sku.eto_select_mps_pn" />
                  </div>
                </div>
                <div class="header-col">
                  <div>SHIP P/N<span class="text-danger pl-1">*</span></div>
                  <div class="flex-fill">
                    <gtc-text-box :read-only="true" class="" v-model="basic_info_review.eto_sector_sku.eto_select_ship_pn" />
                  </div>
                </div>
                <div class="border-bottom"></div>
                <div class="header-col">
                  <div>
                    Conditions & Limitations
                  </div>
                  <div>
                    <b-form-checkbox v-model="hasRemark"
                                     name="check-button"
                                     disabled
                                     switch>
                      This ETO Sector SKU <span v-if="hasRemark"><b>has</b></span>
                      <span v-else><b>has no</b></span>
                      additional conditions and limitations
                      <button class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                              v-b-tooltip.hover.right
                              title="This remark will pass to eQuote, appending in the quotation line.">
                      </button>
                    </b-form-checkbox>

                  </div>
                </div>
                <div v-if="hasRemark" class="flex-fill">

                  <b-form-textarea v-if="hasRemark"
                                   id="textarea-plaintext"
                                   class="w-100"
                                   style="background: #eee;"
                                   plaintext :value=" _.get(nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.remark', '')">
                  </b-form-textarea>
                </div>
                <div class="border-bottom"></div>
                <div class="header-col">
                  <div>Document Link</div>
                  <div class="flex-fill">
                    <div v-if="hasDocumentLink">
                      <b-link :href="safeUrl(_.get(nrePage.nreData.page_object.basic_info_review, 'eto_sector_sku.document', ''))">{{_.get(nrePage.nreData.page_object.basic_info_review, 'eto_sector_sku.document', '')}}</b-link>
                    </div>
                    <div v-else>
                      <gtc-text-box :read-only="true"
                                    class=""
                                    v-model="nullValModel" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--#endregion ETO Sector SKU INFO : P/N -->

      <!--#region Customize Quote Items-->
      <div class="stage-body-customize-quote-items border-bottom pb-4 mb-4">
        <div class="caption-label d-flex">
          <div v-if="$attrs.isETOSELECT">ETO Sector SKU Quote Items (to eQuote)</div>
          <div v-else>Customize Quote Items</div>
        </div>
        <div>
          <b-table small thead-class="thead-light text-dark"
                   :items="$attrs.quoteItemsMapping" :fields="nrePage.customizeQuoteItemsSetting">
            <template #cell(sku_id)="data">
              <div v-if="$attrs.isETOSELECT">
                {{basic_info_review.eto_sector_sku.eto_select_ship_pn}}
              </div>
              <div v-else>
                {{ data.item.sku_id }}
              </div>
            </template>
            <template #cell(qty)="data">
              {{ data.item.qty | comma(0) }}
            </template>
            <template #cell(amortize_qty)="data">
              <div v-if="['MP', 'MP Addition Cost'].includes(data.item.quote_type)" v-for="item in data.item.details">
                <div v-if="data.item.details.length > 1 || data.item.create_function !== 'ES PM'"
                     class="position-absolute px-3 text-left text-white"
                     :class="{'bg-primary': item.create_function === createFunction,
                              'bg-gray-560': item.create_function !== createFunction}"
                     style="width: 20rem;">
                  {{ item.create_function }}
                </div>
                <div :class="{'pt-4':data.item.details.length > 1 || data.item.create_function !== 'ES PM'}">{{ item.amortize_qty | comma(0) }}</div>
              </div>
            </template>
            <template #cell(hq_cost)="data">
              <div v-for="item in data.item.details">
                <div :class="{'pt-4':data.item.details.length > 1 || data.item.create_function !== 'ES PM'}">{{ item.hq_cost | comma }}</div>
              </div>
            </template>
            <template #cell(gro_cost)="data">
              <div v-for="item in data.item.details">
                <div :class="{'pt-4':data.item.details.length > 1 || data.item.create_function !== 'ES PM'}">{{ item.gro_cost | comma }}</div>
              </div>
            </template>
            <template #cell(selling_price)="data">
              <div v-for="item in data.item.details">
                <div :class="{'pt-4':data.item.details.length > 1 || data.item.create_function !== 'ES PM'}">{{ item.selling_price | comma }}</div>
              </div>
            </template>
            <template #cell(action)="data">
              <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit" @click="$emit('quoteItemModal', data.item)"></button>
              <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-delete" @click="$emit('removeQuoteItem',data.item)"></button>
            </template>
          </b-table>
        </div>
      </div>
      <!--#endregion-->
      <!--#region GTC Sales Comments and Conclusions-->
      <div class="stage-body-gtc-sales-comments-and-conclusions border-bottom pb-4 mb-4">
        <div class="caption-label d-flex">
          <div>GTC Sales Comments and Conclusions</div>
        </div>
        <div>
          <gtc-froala :read-only="true" v-model="nrePage.nreData.page_object.gtc_comment" />
        </div>
      </div>
      <!--#endregion-->
      <!--#region Customize NRE/Cost Notification-->
      <div class="stage-body-customize-nre-cost-notification">
        <div class="caption-label d-flex">
          <div>Customize NRE/Cost Notification</div>
        </div>
        <div>
          <div class="header-col align-items-start">
            <div>GRO Owner</div>
            <div class="align-items-center flex-fill overflow-auto">
              <div class="text-primary font-weight-bold">{{ _.get(basic_info_review, 'gro_owner', '') }}</div>
            </div>
          </div>
          <div class="header-col align-items-start">
            <div>GTC Owner</div>
            <div class="align-items-center flex-fill overflow-auto">
              <div class="text-primary font-weight-bold">{{ _.get(basic_info_review, 'gtc_owner', '') }}</div>
            </div>
          </div>
          <div class="header-col align-items-start">
            <div>RSM (contact Sales)</div>
            <div class="align-items-center flex-fill overflow-auto">
              <div class="text-primary font-weight-bold">{{ _.get(basic_info_review, 'contact_sales', '') }}</div>
            </div>
          </div>
          <div class="header-col align-items-start">
            <div>Recipient Group</div>
            <div class="align-items-center flex-fill overflow-auto">
              <div v-if="!$attrs.readOnly && !nrePage.isSubmitted" class="text-primary font-weight-bold">{{ _.get(selectedMailGroup, 'group_name', '') }}</div>
              <div v-else class="text-primary font-weight-bold">{{nrePage.nreData.page_object.chosen_mail_group_name}}</div>
              <div class="my-3" v-if="!$attrs.readOnly">
                <button class="btn btn-sm btn-primary" @click="mailGroupAdd">Add New Recipient Group</button>
              </div>
              <div>
                <b-table small thead-class="thead-light text-dark"
                         :items="mail_group" :fields="nrePage.mailGroupSetting">
                  <template #cell(chosen)="data">
                    <b-form-radio name="some-radios" :value="data.index" :disabled="$attrs.readOnly" v-model="selectedMailGroupIndex"></b-form-radio>
                  </template>
                  <template #cell(group_name)="data">
                    <div v-if="!$attrs.readOnly && !nrePage.isSubmitted"> {{ data.value }}</div>
                    <div v-else>{{nrePage.nreData.page_object.chosen_mail_group_name}}</div>
                  </template>
                  <template #cell(site)="data">
                    {{ data.value }}
                  </template>
                  <template #cell(action)="data">
                    <button :id="`mail-group-button-${data.index}`" type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-more"></button>
                    <b-popover :target="`mail-group-button-${data.index}`" custom-class="menu" triggers="focus">
                      <div class="list-group list-group-flush">
                        <button type="button" class="px-2 py-1 list-group-item list-group-item-action" @click="mailGroupEdit(data.index)">Edit</button>
                        <!--<button type="button" class="px-2 py-1 list-group-item list-group-item-action" @click="mailGroupDuplicate(data.index)">Duplicate</button>-->
                        <button type="button" class="px-2 py-1 list-group-item list-group-item-action" @click="mailGroupDelete(data.index)">Delete</button>
                      </div>
                    </b-popover>
                  </template>
                  <template #cell()="data">
                    <div v-for="item in _.get(data.item, data.field.key, [])">
                      {{item.member_name}}
                    </div>
                  </template>

                </b-table>
              </div>
            </div>
          </div>
          <b-card no-body v-if="!$attrs.readOnly">
            <b-tabs card>
              <b-tab title="Template">
                <gtc-froala :read-only="false" v-model="nrePage.nreData.page_object.mail_template" />
              </b-tab>
              <b-tab title="Preview" class="p-0">
                <gtc-froala :read-only="true" v-model="$attrs.mailMessagePreview" class="bg-white border-0" />
              </b-tab>
            </b-tabs>
          </b-card>
          <gtc-froala v-else :read-only="true" v-model="nrePage.nreData.page_object.mail_template_exclude_regexp" class="bg-white" />
        </div>
      </div>
      <!--#endregion-->
      <!--#region NEW!! Reject Reason Section-->
      <div v-if="$attrs.showReasonSection" class="stage-body-gtc-sales-comments-and-conclusions">
        <br />
        <div class="caption-label d-flex">
          <div>
            <span class="badge badge-danger" style="font-size: 16px;margin-bottom: 5px;">GRO SA Head Reject Reason</span>
          </div>
        </div>
        <div>
          <gtc-froala :read-only="true" v-model="nrePage.nreData.page_object.reject_reason" />
        </div>
      </div>
      <!--#endregion-->

    </div>
    <div class="fixed-bottom d-print-none" v-if="!$attrs.readOnly && !nrePage.isSubmitted">
      <div class="row py-3 bg-gray-150 px-4 border-top border-gray-550">
        <div class="col-auto ml-auto p-0"></div>
        <div class="col-auto">
          <button type="button" class="btn btn-success min-w-6" @click="$emit('save')">Save</button>
        </div>
        <div class="col-auto border-left p-0 border-gray-550" style="width:1px"></div>
        <div class="col-auto">
          <button type="button" class="btn btn-danger" @click="$emit('reject')">Reject</button>
          <button type="button" class="btn btn-warning" @click="$emit('return')">Return</button>
          <button type="button" class="btn btn-primary" @click="$emit('submit')">Submit</button>
        </div>
      </div>
    </div>

    <!--#endregion-->
    <!--#region -- Mail Group Modal ---->

    <b-modal centered size="lg" :ok-title="`${_.get(mailGroupItem, 'isAdd', true) ? 'Add':'Save'}`" @ok="mailGroupAddOrEdit"
             ref="mailGroupModal" :title="`${_.get(mailGroupItem, 'isAdd', true) ? 'Add':'Edit'} Mail Group`"
             button-size="sm">
      <div v-if="mailGroupItem">
        <div class="header-col validate">
          <div>Mail Group Name<span class="text-danger pl-1">*</span></div>
          <div>
            <gtc-text-box :readOnly="!_.get(mailGroupItem, 'isAdd', true)" class="form-control form-control-sm" required
                          v-model="mailGroupItem.group_name" :class="{'is-invalid': _.get(mailGroupItem, 'group_name_state', 0) > 0}" />
            <div class="invalid-feedback">
              {{ _.get(mailGroupItem, 'group_name_state', 0) == 1 ? 'Please enter Mail Group Name' : 'The group name must be unique.'  }}
            </div>
          </div>
        </div>
        <div class="header-col">
          <div>Site<span class="text-danger pl-1">*</span></div>
          <div>
            <select class="form-control form-control-sm" v-model="mailGroupItem.site">
              <option v-for="site in nrePage.nreData.page_object.mail_group_options.site_options" :value="site">{{ site }}</option>
            </select>
          </div>
        </div>
        <div class="border-bottom my-4"></div>
        <div class="row mx-n1">
          <div class="col-6 px-1" v-for="(cellData, key) in mailGroupModalSetting">
            <div class="header-col">
              <div>{{ cellData.name }}</div>
              <div class="flex-fill">
                <gtc-multi-select v-model="mailGroupItem[key]"
                                  key-field="member_email" text-field="member_name"
                                  :options="cellData.options" select-class="w-100" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!--#endregion-->
  </div>
</template>
<script>
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    data() {
      return {
        mailGroupItem: null,
        nullValModel: 'N/A'
      };
    },
    created() {
      let self = this;
      if (!self.$attrs.readOnly) {
          self.$emit('refreshQuoteItems');
      }
    },
    computed: {
      hasRemark() {
        let self = this;
        if (_.get(self.nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.remark', null) === null
          || _.get(self.nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.remark', null) === 'None'
          || _.get(self.nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.remark', null) === '') {
          return false
        } else {
          return true
        }
      },
      hasDocumentLink() {
        let self = this;
        if (_.get(self.nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.document', null) === null
          || _.get(self.nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.document', null) === 'None'
          || _.get(self.nrePage, 'nreData.page_object.basic_info_review.eto_sector_sku.document', null) === '') {
          return false
        } else {
          return true
        }
      },
      pocRequired() {
        return this.nre_estimation_hq_sales.poc_required === 'Y';
      },

      canWithdraw() {
        let self = this;
        let isAwaiting = self.nrePage.nreData.espm_leader_status === 'Waiting' ||
          self.nrePage.nreData.espm_leader_status === 'W';
        return isAwaiting && self.$attrs.isSubmitted && self.$attrs.readOnly;
      },

      //#region -- Alias --

      stageNumber() {
        return this.$attrs.stageNumber;
      },
      createFunction() {
        return this.$attrs.createFunction;
      },
      skuItem() {
        return this.$attrs.skuItem;
      },
      nrePage: {
        get() {
          return this.$attrs.data;
        },
        set(value) {
          this.$attrs.data = value;
        }
      },
      basic_info_review: {
        get() {
          return this.nrePage.nreData.page_object.basic_info_review;
        },
        set(value) {
          this.nrePage.nreData.page_object.basic_info_review = value;
        }
      },
      nre_estimation_hq_sales: {
        get() {
          return this.nrePage.nreData.page_object.nre_estimation_hq_sales;
        },
        set(value) {
          this.nrePage.nreData.page_object.nre_estimation_hq_sales = value;
        }
      },
      proposal_files: {
        get() {
          return this.nrePage.nreData.page_object.proposal_files;
        },
        set(value) {
          this.nrePage.nreData.page_object.proposal_files = value;
        }
      },
      reference_files: {
        get() {
          return this.nrePage.nreData.page_object.reference_files;
        },
        set(value) {
          this.nrePage.nreData.page_object.reference_files = value;
        }
      },
      lead_time_notice: {
        get() {
          return this.nrePage.nreData.page_object.lead_time_notice;
        },
        set(value) {
          this.nrePage.nreData.page_object.lead_time_notice = value;
        }
      },
      quote_items: {
        get() {
          return this.nrePage.nreData.page_object.quote_items;
        },
        set(value) {
          this.nrePage.nreData.page_object.quote_items = value;
        }
      },
      unit_estimation_hq_sales: {
        get() {
          return this.nrePage.nreData.page_object.unit_estimation_hq_sales;
        },
        set(value) {
          this.nrePage.nreData.page_object.unit_estimation_hq_sales = value;
        }
      },
      nre_estimation_curr_stage: {
        get() {
          return this.nrePage.nreData.page_object.nre_estimation_curr_stage;
        },
        set(value) {
          this.nrePage.nreData.page_object.nre_estimation_curr_stage = value;
        }
      },
      unit_estimation_curr_stage: {
        get() {
          return this.nrePage.nreData.page_object.unit_estimation_curr_stage;
        },
        set(value) {
          this.nrePage.nreData.page_object.unit_estimation_curr_stage = value;
        }
      },

      //#region -- Mail Group --

      mail_group: {
        get() {
          return this.nrePage.nreData.page_object.mail_group;
        },
        set(value) {
          this.nrePage.nreData.page_object.mail_group = value;
        }
      },
      selectedMailGroupIndex: {
        get() {

          if (_.get(this.mail_group, 'length', 0) === 0) return -1;

          let selectedIndex = _.findIndex(this.mail_group, { chosen: true });
          if (selectedIndex < 0) {
            this.mail_group[0]['chosen'] = true;
            selectedIndex = 0;
          }
          return selectedIndex;
        },
        set(index) {
          if (index < 0 || _.get(this.mail_group, 'length', 0) === 0) return;

          _.each(_.filter(this.mail_group, { chosen: true }), item => {
            item['chosen'] = false;
          });

          this.mail_group[index]['chosen'] = true;
        }
      },
      selectedMailGroup() {
        if ('' !== this.nrePage.nreData.page_object.chosen_mail_group_name) {
          return this.nrePage.nreData.page_object.chosen_mail_group_name;
        }
        if (this.selectedMailGroupIndex === -1) return null;
        return this.mail_group[this.selectedMailGroupIndex];
      },

      mailGroupKeys() {
        return {
          'rsm': 'RSM',
          'sa_team': 'SA Team',
          'sales_director': 'Sales Director',
          'ofd': 'OFD',
          'inside_sales': 'Inside Sales',
          'gro_head': 'GRO Head',
          'hq_sales': 'HQ Sales',
          'others': 'Others',
        }
      },
      mailGroupModalSetting() {
        let self = this;

        let output = {};

        _.each(self.mailGroupKeys, (name, key) => {
          output[key] = {
            name: name,
            options: _.map(_.get(self.nrePage.nreData.page_object.mail_group_options.member_options, `${key}_options`, []),
              option => {
                option.member_function = name;
                return option;
              })
          };
        });

        return output;
      },

      //#endregion

      //#endregion
      //#region -- Price --

      jobCost() {
        return {
          poc_cost: _.sum(_.map(this.nre_estimation_hq_sales.job_cost, item => { return _.get(item, 'poc_cost', 0); })),
          mp_cost: _.sum(_.map(this.nre_estimation_hq_sales.job_cost, item => { return _.get(item, 'mp_cost', 0); }))
        };
      },
      regulation() {
        return {
          poc_cost: _.sum(_.map(this.nre_estimation_hq_sales.regulation, item => { return _.get(item, 'poc_cost', 0); })),
          mp_cost: _.sum(_.map(this.nre_estimation_hq_sales.regulation, item => { return _.get(item, 'mp_cost', 0); }))
        };
      },

      test_sample_mp_cost() {
        let self = this;

        let mp_cost_base_unit = self.unit_estimation_hq_sales.cost_base_unit.mp_cost;
        let mp_cost_add_material = self.unit_estimation_hq_sales.additional_material_cost.mp_cost;
        let mp_cost_add_mva = self.unit_estimation_hq_sales.additional_mva_cost.mp_cost;
        let eqt_test_sample_qty = self.nre_estimation_hq_sales.test_sample.eqt_sample;
        let sharing_rate_test_sample = self.nre_estimation_hq_sales.test_sample.sharing_rate;
        let result = (mp_cost_base_unit + mp_cost_add_material + mp_cost_add_mva) * eqt_test_sample_qty * (sharing_rate_test_sample / 100);

        self.nre_estimation_hq_sales.test_sample.mp_cost = _.round(result, 2);

        return self.nre_estimation_hq_sales.test_sample.mp_cost;
      },
      nre_estimation_total_poc_cost() {
        let self = this;
        let cols = [
          self.nre_estimation_hq_sales.labor_cost.poc_cost,
          self.nre_estimation_hq_sales.test_sample.poc_cost,
          self.nre_estimation_hq_sales.job_cost.poc_cost,
          self.nre_estimation_hq_sales.regulation.regulation_others.poc_cost,
          self.nre_estimation_hq_sales.others.poc_cost
        ];
        let result = _.round(_.sum(cols), 2);
        self.nre_estimation_hq_sales.total_cost.poc_cost = result;
        return result;
      },
      nre_estimation_total_mp_cost() {
        let self = this;
        let cols = [
          self.nre_estimation_hq_sales.labor_cost.mp_cost,
          self.nre_estimation_hq_sales.test_sample.mp_cost,
          self.nre_estimation_hq_sales.job_cost.mp_cost,
          self.nre_estimation_hq_sales.regulation.regulation_others.mp_cost,
          self.nre_estimation_hq_sales.others.mp_cost
        ];
        let result = _.round(_.sum(cols), 2);
        self.nre_estimation_hq_sales.total_cost.mp_cost = result;
        return result;
      },

      nre_estimation_total_poc_cost_curr_stage() {
        let self = this;
        let cols = [
          self.nre_estimation_curr_stage.labor_cost.poc_cost,
          self.nre_estimation_curr_stage.test_sample.poc_cost,
          self.nre_estimation_curr_stage.job_cost.poc_cost,
          self.nre_estimation_curr_stage.regulation.regulation_others.poc_cost,
          self.nre_estimation_curr_stage.total_cost.poc_cost
        ];
        let result = _.round(_.sum(cols), 2);
        // self.nre_estimation_curr_stage.total_cost.poc_cost = result;
        return result;
      },
      nre_estimation_total_mp_cost_curr_stage() {
        let self = this;
        let cols = [
          self.nre_estimation_curr_stage.labor_cost.mp_cost,
          self.nre_estimation_curr_stage.test_sample.mp_cost,
          self.nre_estimation_curr_stage.job_cost.mp_cost,
          self.nre_estimation_curr_stage.regulation.regulation_others.mp_cost,
          self.nre_estimation_curr_stage.total_cost.mp_cost
        ];
        let result = _.round(_.sum(cols), 2);
        // self.nre_estimation_curr_stage.total_cost.mp_cost = result;
        return result;
      },

      nre_amortization_cost_hq_result() {
        let self = this;
        let mp_cost = self.nre_estimation_total_mp_cost;
        let amortization_quantity = self.unit_estimation_curr_stage.nre_amortization.nre_amortization_quantity;

        let result = 0;
        if ('Y' === self.unit_estimation_curr_stage.nre_amortization.nre_amortization_check && amortization_quantity !== 0) {
          result = _.round(mp_cost / amortization_quantity, 2);
        }

        self.unit_estimation_hq_sales.nre_amortization.nre_amortization_cost = result;
        return result;
      },
      nre_amortization_cost_gro_result() {
        let self = this;
        let mp_cost = self.nre_estimation_total_mp_cost_curr_stage;
        let amortization_quantity = self.unit_estimation_curr_stage.nre_amortization.nre_amortization_quantity;

        let result = 0;
        if ('Y' === self.unit_estimation_curr_stage.nre_amortization.nre_amortization_check && amortization_quantity !== 0) {
          result = _.round(mp_cost / amortization_quantity, 2);
        }

        self.unit_estimation_curr_stage.nre_amortization.nre_amortization_cost = result;
        return result;
      },
      unit_estimation_total_hq_poc_cost() {
        let self = this;
        let cols = [
          self.unit_estimation_hq_sales.cost_base_unit.poc_cost,
          self.unit_estimation_hq_sales.additional_material_cost.poc_cost,
          self.unit_estimation_hq_sales.additional_mva_cost.poc_cost
        ];
        let result = _.round(_.sum(cols), 2);
        self.unit_estimation_hq_sales.total_cost.poc_cost = result;
        return result;
      },
      unit_estimation_total_hq_mp_cost() {
        let self = this;
        let cols = [
          self.unit_estimation_hq_sales.nre_amortization.nre_amortization_cost,
          self.unit_estimation_hq_sales.cost_base_unit.mp_cost,
          self.unit_estimation_hq_sales.additional_material_cost.mp_cost,
          self.unit_estimation_hq_sales.additional_mva_cost.mp_cost
        ];
        let result = _.round(_.sum(cols), 2);
        self.unit_estimation_hq_sales.total_cost.mp_cost = result;
        return result;
      },
      unit_estimation_total_gro_poc_cost() {
        let self = this;
        let cols = [
          self.unit_estimation_curr_stage.cost_base_unit.poc_cost,
          self.unit_estimation_curr_stage.additional_material_cost.poc_cost,
          self.unit_estimation_curr_stage.additional_mva_cost.poc_cost
        ];
        let result = _.round(_.sum(cols), 2);
        self.unit_estimation_curr_stage.total_cost.poc_cost = result;
        return result;
      },
      unit_estimation_total_gro_mp_cost() {
        let self = this;
        let cols = [
          self.unit_estimation_curr_stage.nre_amortization.nre_amortization_cost,
          self.unit_estimation_curr_stage.cost_base_unit.mp_cost,
          self.unit_estimation_curr_stage.additional_material_cost.mp_cost,
          self.unit_estimation_curr_stage.additional_mva_cost.mp_cost
        ];
        let result = _.round(_.sum(cols), 2);
        self.unit_estimation_curr_stage.total_cost.mp_cost = result;
        return result;
      },

      //#endregion
    },
    methods: {
      showMailGroupDialog(item) {
        let self = this;

        if (_.isNil(item)) {
          item = {};

          if (self.nrePage.nreData.page_object.mail_group_options.site_options.length === 1) {
            item.site = self.nrePage.nreData.page_object.mail_group_options.site_options[0];
          }

          _.each(self.mailGroupModalSetting, (cellData, key) => {
            item[key] = cellData.options.length === 1 ? [cellData.options[0]] : [];
          });
        }

        self.mailGroupItem = {
          ...item,
          isAdd: _.trim(item.group_name) === '',
          group_name_state: 0
        };

        self.$refs['mailGroupModal'].show();
      },
      mailGroupAddOrEdit(bvModalEvt) {
        let self = this;

        bvModalEvt.preventDefault();

        if (_.trim(self.mailGroupItem.group_name) === '')
          self.mailGroupItem.group_name_state = 1;

        if (_.get(self.mailGroupItem, 'isAdd', true) && _.findIndex(self.mail_group, { group_name: self.mailGroupItem.group_name }) !== -1)
          self.mailGroupItem.group_name_state = 2;


        if (self.mailGroupItem.group_name_state > 0) return;

        let requestData = {
          ftie_id: self.nrePage.nreData.page_object.basic_info_review.ftie_id,
          nre_id: self.nrePage.nreData.page_object.basic_info_review.nre_id,
          real_sku_no: self.nrePage.nreData.page_object.basic_info_review.real_sku_no,
          create_by: self.$attrs.createBy,
          username: self.$attrs.loginUser,
          create_date: self.$root.getTime(),
          mail_group: self.mailGroupItem,
        };

        let url = `${self.$root.baseUrl}/mail-management/mail-group-edit/`;

        eventHub.$emit('loading', true);
        self.$axios
          .post(url, requestData)
          .then(response => {
            if (response.status == 200) {
              let res = response.data;
              if (res['save_mail_group_success']) {
                self.mail_group = JSON.parse(res['mail_group']);
                self.mailGroupItem = null;

                self.$nextTick(() => {
                  self.$refs['mailGroupModal'].hide();
                });

              }
              else {
                this.$message.error(`${self.mailGroupItem.isAdd ? 'Add' : 'Modify'} Mail Group Fail!`);
              }
            }
            else {
              this.$message.error(`${self.mailGroupItem.isAdd ? 'Add' : 'Modify'} Mail Group Fail!`);
            }
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });

      },
      mailGroupAdd() {
        this.showMailGroupDialog(null);
      },
      mailGroupEdit(index) {
        this.showMailGroupDialog(this.mail_group[index]);
      },
      mailGroupDuplicate(index) {

      },
      mailGroupDelete(index) {

        let self = this;
        let deleteObj = self.mail_group[index];
        if (_.isNil(deleteObj)) return;


        let requestData = {
          ftie_id: self.nrePage.nreData.page_object.basic_info_review.ftie_id,
          nre_id: self.nrePage.nreData.page_object.basic_info_review.nre_id,
          real_sku_no: self.nrePage.nreData.page_object.basic_info_review.real_sku_no,
          create_by: self.$attrs.createBy,
          username: self.$attrs.loginUser,
          site: deleteObj.site,
          group_name: deleteObj.group_name,
          create_function: 'SA Head Review'
          //mail_group: self.mailGroupItem,
        };

        //let url = `${self.$root.baseUrl}/mail-management/mail-group-edit/?site=${deleteObj.site}&group_name=${deleteObj.group_name}`;
        let url = `${self.$root.baseUrl}/mail-management/mail-group-delete/`;
        eventHub.$emit('loading', true);

        self.$axios
          .post(url, requestData)
          .then(response => {
            if (response.status == 200) {
              let res = response.data;
              if (res['delete_mail_group_success']) {
                self.mail_group = JSON.parse(res['mail_group']);
              }
              else {
                this.$message.error('Delete Mail Group Fail!');
              }
            }
            else {
              this.$message.error('Delete Mail Group Fail!');
            }
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });

        // OLD VERSION - USING GET
        /*
        self.$axios
          .get(url)
          .then(response => {
            if (response.status == 200) {
              let res = response.data;
              if (res['delete_mail_group_success']) {
                self.mail_group = JSON.parse(res['mail_group']);
              }
              else {
                this.$message.error('Delete Mail Group Fail!');
              }
            }
            else {
              this.$message.error('Delete Mail Group Fail!');
            }
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
          */

      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SAHeadReview.vue